// internal
import { axios, def, handleError, handleResponse } from './internal';

// client-shared
import { storage } from '@goldblack/client-storage';

function AdminUserChangeStatus(userId, status, expire, forced, reason) {
    axios
        .post('/api/admin_user_changestatus', {
            userId,
            status,
            forced,
            expire,
            reason,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { user } = res.data.data;

                    let callback = (x) => x._id === user._id;
                    storage.transience.updateState('search.result', callback, user);

                    storage.transience.setState('internal.success', 'The user status has been updated.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserChangeStatus };
